export function getSelectedRowsCount(self) {
  var phase_rows = self.get_phase_rows();
  var isCategorical = !!phase_rows.find('input:radio, input:checkbox').length;
  var num_selected = 0;
  phase_rows.each(function () {
    var phase_row = $(this);

    if (isCategorical) {
      if (phase_row.find('input:checked').length) {
        num_selected++;
      }
    } else {
      var inputs = phase_row.find('input:text');
      var answers = 0;
      inputs.each(function () {
        if ($(this).val() !== '') {
          answers += 1;
        }
      });
      if (answers === inputs.length) {
        num_selected += 1;
      }
    }
  });
  return num_selected;
}
